
import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import Top100App from '../../components/top100/index';
import { getListMusicsIfNeeded } from '../../components/top100/actions/Top100Actions';

const As100Mais = () => {
    const { slug } = useParams();

    return (
        <div className="pageWrapper tw-container tw-m-auto tw-px-5">
            <Top100App slug={slug} />
        </div>
    );
};

As100Mais.fetchData = (store, match) => store.dispatch(getListMusicsIfNeeded(match.params.slug));

As100Mais.propTypes = exact({});

export default As100Mais;
